import { Component } from 'react';

// Services
import { numbersToLocaleString, localStringToNumbers } from '../../services';

// Components
import CustomModal from 'components/CustomModal';
import { InputField } from 'components/Fields';
import InputPrice from '../InputPrice';

// Styles
import * as styles from './styles';
import * as inputStyles from 'components/Fields/InputFields/styles';

const customStyles = {
  content: {
    width: '483px',
    maxWidth: '483px'
  }
};

const initialState = {
  name: null,
  nomenclature: null,
  price: '',
  errors: {}
};

class CustomServiceModal extends Component {
  constructor() {
    super();
    this.state = Object.assign({}, initialState);
    this.closeModal = this.closeModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeInput = this.onChangeInput.bind(this);
    this.validateAndSubmit = this.validateAndSubmit.bind(this);
  }

  closeModal() {
    this.setState(Object.assign({}, initialState));
    this.props.closeModal();
  }

  handleSubmit() {
    this.validateAndSubmit(true);
  }

  onChangeInput(e) {
    if (e && e.target) {
      const name = e.target.name;
      const value = name === 'price' ? numbersToLocaleString(e.target.value) : e.target.value;
      if (this.state.errors[name]) {
        const errors = Object.assign({}, this.state.errors);
        delete errors[name];
        this.setState({ [name]: value, errors });
      } else {
        this.setState({ [name]: value });
      }
    }
  }

  validateAndSubmit(isSubmit) {
    const errors = {};
    const { name, price } = this.state;
    if (!name) {
      errors.name = 'sorry_this_is_mandatory';
    }
    if (!price) {
      errors.price = 'sorry_this_is_mandatory';
    }
    const errorKeys = Object.keys(errors);
    if (!errorKeys.length && isSubmit) {
      const sendData = {
        name: this.state.name,
        nomenclature: this.state.nomenclature,
        price: Number(localStringToNumbers(this.state.price)),
      };
      this.props.onSubmit && this.props.onSubmit(sendData);
      this.setState({ errors: {} });
      this.closeModal();
    } else {
      this.setState({ errors });
    }
  }

  render() {
    const { isOpen, i18n } = this.props;
    const { errors, price } = this.state;

    return (
      <CustomModal
        isOpen={isOpen}
        onRequestClose={this.closeModal}
        style={customStyles}
        contentLabel=""
      >
        <styles.ModalCloseIcon onClick={this.closeModal} />

        <styles.ModalTitle>
          {i18n.t('custom_item_modal_title')}
        </styles.ModalTitle>
        <styles.ModalText>
          {i18n.t('custom_item_modal_form_caption')}
        </styles.ModalText>

        {/* ──── Form ───────────────────────────────────────────────────────────────────────── */}

        <styles.Form>
          <InputField
            input={{ name: 'name', onChange: this.onChangeInput }}
            meta={{ error: errors.name, touched: errors.name }}
            label={i18n.t('custom_item_modal_field_name')}
            placeholder={i18n.t('custom_item_modal_field_name_placeholder')}
          />

          <InputField
            type="number"
            input={{
              name: 'nomenclature',
              onChange: this.onChangeInput
            }}
            label={i18n.t('custom_item_modal_field_nomenclature')}
            isRequired={false}
            placeholder={i18n.t(
              'custom_item_modal_field_nomenclature_placeholder'
            )}
          />

          {/* ──── Price field ─────────────────────────────────────────────────────────────── */}
          <div style={{ marginBottom: '30px' }}>
            {/* Label */}

            <inputStyles.InputLabel>
              {i18n.t('custom_item_modal_field_price')}
              <inputStyles.Required> *</inputStyles.Required>
            </inputStyles.InputLabel>

            <InputPrice
              style={styles.PriceInput(errors.price)}
              onChange={value => {
                this.onChangeInput({ target: { name: 'price', value: value } });
              }}
              placeholder={i18n.t('custom_item_modal_field_price_placeholder')}
            />
            {/* Errors */}

            {errors.price && (
              <inputStyles.ErrorMessage>
                {typeof errors.price === 'string' && i18n.t(errors.price)}
              </inputStyles.ErrorMessage>
            )}
          </div>
        </styles.Form>

        <styles.ModalLine />

        {/* ──── Footer ────────────────────────────────────────────────────────────────────── */}
        <div style={{ position: 'relative', textAlign: 'right' }}>
          <styles.ModalCancel onClick={this.closeModal}>
            {i18n.t('popup_cancel_button')}
          </styles.ModalCancel>

          <styles.ModalButtonConfirm onClick={this.handleSubmit}>
            {i18n.t('custom_item_modal_add_btn')}
          </styles.ModalButtonConfirm>
        </div>
      </CustomModal>
    );
  }
}

export default CustomServiceModal;
